import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const analyticsSniffing: Example = {
  id: "analytics-sniffing",
  title: "Scanning for analytics",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "Checks for analytics globals and only phones home when none exist",
  explainer:
    "Each `typeof ga` or `'hj' in window` shows up as a PROBE event, even though those " +
    "globals don't exist. On this bare page nothing is found, so the script reports in. " +
    "Switch the context's decoys to Typical storefront and it finds `ga` and stays quiet.",
  code,
  context: { decoys: [] },
  expect: golden as Example["expect"],
};
